import {
  CARE_SERVICE_ORGANS_PARENT_KEY,
  ConditionTemplate,
  RenderedSummaryStatus,
  TextToStructuredObservation,
} from '@/api';

export const DEGENERATIVE_CHANGE_CONDITION = 'degenerative_change' as const;

const DEGENERATIVE_CHANGE_CONDITION_TEMPLATE_UUID = 'DegenerativeChange-conditions';

export const DEGENERATIVE_CHANGE_CONDITIONS = [
  'degenerative_change_of_the_cervical_spine',
  'degenerative_change_of_the_thoracic_spine',
  'degenerative_change_of_the_lumbar_spine',
];

export const DEGENERATIVE_CHANGE_LABELS: {
  [key: string]: string;
} = {
  clinical_notes_placeholder:
    'FCT.REPORTING.ENTRY.ORGAN.FINDING.DEGENERATIVE_CHANGE_CONDITIONS.LABELS.CLINICAL_NOTES_PLACEHOLDER',
  degenerative_change_of_the_cervical_spine:
    'FCT.REPORTING.ENTRY.ORGAN.FINDING.DEGENERATIVE_CHANGE_CONDITIONS.LABELS.DEGENERATIVE_CHANGE_OF_THE_CERVICAL_SPINE',
  degenerative_change_of_the_lumbar_spine:
    'FCT.REPORTING.ENTRY.ORGAN.FINDING.DEGENERATIVE_CHANGE_CONDITIONS.LABELS.DEGENERATIVE_CHANGE_OF_THE_LUMBAR_SPINE',
  degenerative_change_of_the_thoracic_spine:
    'FCT.REPORTING.ENTRY.ORGAN.FINDING.DEGENERATIVE_CHANGE_CONDITIONS.LABELS.DEGENERATIVE_CHANGE_OF_THE_THORACIC_SPINE',
  input_placeholder:
    'FCT.REPORTING.ENTRY.ORGAN.FINDING.DEGENERATIVE_CHANGE_CONDITIONS.LABELS.INPUT_PLACEHOLDER',
};

export const DEGENERATIVE_CHANGE_CONDITION_TEMPLATE: ConditionTemplate = {
  condition: DEGENERATIVE_CHANGE_CONDITION,
  conditionDetail: [],
  displayName: 'Degenerative Changes',
  isSingleObservation: false,
  normalStatementOutcome: {},
  organ: CARE_SERVICE_ORGANS_PARENT_KEY.SPINE,
  uuid: DEGENERATIVE_CHANGE_CONDITION_TEMPLATE_UUID,
  version: '1.0.0',
};

export const DEGENERATIVE_CHANGE_FINDING: TextToStructuredObservation = {
  conditionTemplate: DEGENERATIVE_CHANGE_CONDITION_TEMPLATE,
  renderedSummary: {
    actionDetails: '',
    actionSummary: '',
    additionalRecommendations: null,
    aiAcknowledged: false,
    clinicalNotes: null,
    createdAt: '',
    createdBy: '',
    csdScore: 0,
    findingDetails: 'We detected evidence of degenerative change.',
    findingSummary: '',
    keyImages: [],
    newFinding: false,
    oncoradsScore: 0,
    reportFindings: [],
    reportFindingsUuids: [],
    reportUuid: '',
    status: '' as RenderedSummaryStatus,
    uuid: 'DegenerativeChange-rendered-summary',
  },
};
